<template>
  <div class="pages-search">
    <div class="">
      <div class="top-line">
        <div class="small-button" @click="toBack()">返回</div>
      </div>
      <div class="search-input">
        <input
          id="input"
          class="input-value"
          placeholder="请输入搜索关键词"
          type="text"
          :value="inputValue"
          @input="toInputValue"
          v-on:keyup.enter="toSearchClick"
        />
        <!-- <el-input
          class="input-value"
          v-model="inputValue"
          placeholder="请输入搜索关键词"
        ></el-input> -->
        <!-- <div class="btn" @click="toSearch()">搜索</div> -->
        <div class="btn" @click="toSearchClick()">搜索</div>
      </div>
      <div class="search-select">
        <div class="search-select-title">条件筛选：</div>
        <el-select
          v-model="termValue"
          clearable
          placeholder="选择学期"
          style="margin-right: 10px"
        >
          <el-option
            v-for="item in termList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="tagValue"
          clearable
          placeholder="选择标签"
          style="margin-right: 10px"
        >
          <el-option v-for="item in tagList" :key="item" :value="item">
          </el-option>
        </el-select>
        <el-select
          v-model="authorityValue"
          clearable
          placeholder="是否官方配套"
          style="margin-right: 10px"
        >
          <el-option v-for="item in authorityList" :key="item" :value="item">
          </el-option>
        </el-select>
        <el-select
          v-model="fileTypeValue"
          clearable
          placeholder="选择文件类型"
          style="margin-right: 10px"
        >
          <el-option v-for="item in fileTypeList" :key="item" :value="item">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="timeValue"
          type="date"
          placeholder="选择更新时间"
        >
        </el-date-picker>
      </div>

      <!-- <div v-if="showResult" class="result-total">共搜到{{ total }}个资源</div> -->
      <div v-if="showResult" class="result-table">
        <div class="result-total">共搜到{{ total }}个资源</div>
        <el-table :data="data" style="width: 100%; margin-bottom: 10px">
          <!-- height="calc(100vh - 560px)" -->
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">{{
              scope.$index + 1 + (pageNum - 1) * 10
            }}</template>
          </el-table-column>
          <el-table-column
            prop="title"
            label="资源标题"
            min-width="300"
            align="center"
          ></el-table-column>
          <!-- <el-table-column
            prop="tag"
            label="资源标签"
            width="width"
            align="center"
          ></el-table-column> -->
          <el-table-column
            prop="tag"
            label="资源标签"
            min-width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-for="(item, index) in scope.row.tag"
                :key="item"
                :value="item"
                >{{ index > 0 ? ' / ' : '' }}{{ item }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            label="文件类型"
            min-width="150"
            align="center"
          >
            <template slot-scope="scope">
              {{ getFileType(scope.row.urls) }}</template
            >
          </el-table-column>
          <el-table-column
            prop="author"
            label="作者"
            min-width="150"
            align="center"
          >
            <template slot-scope="scope">
              {{ getFileAuthor(scope.row) }}</template
            >
          </el-table-column>
          <el-table-column
            prop="updated_at"
            label="更新时间"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="time"
            label="浏览/收藏/下载"
            min-width="200"
            align="center"
          >
            <template slot-scope="scope">
              <div class="data">
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 17px; height: 12px"
                    :src="require('../../assets/view.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.views || 0) }}
                </div>
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 15px; height: 14px"
                    :src="require('../../assets/collect.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.collect || 0) }}
                </div>
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 14px; height: 14px"
                    :src="require('../../assets/download.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.download || 0) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="200" fixed="right">
            <template slot-scope="scope">
              <div style="display: flex; justify-content: center">
                <div class="small-button" @click="toPreview(scope.row)">
                  查看
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="height: 40px"></div>
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :total="total"
          class="pagination"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
      <div style="height: 40px"></div>
    </div>

    <div v-if="detailShow" class="resource-detail-block">
      <!-- <div class="top-line">
        <div class="small-button" @click="toBack()">返回</div>
        <span class="title">我的主页</span>
      </div> -->
      <!-- 详情 -->
      <resource-detail
        :show="detailShow"
        @onReturn="detailShow = false"
        @updateCollect="this.onUpdateCollect"
        @updateFollow="(val) => (detailData.follow = val)"
        :detailData="detailData"
        detailType="2"
        isSearch
        :origin="origin"
      ></resource-detail>
    </div>
  </div>
</template>

<script>
import { getTerm, getTags, findResource, group, resDetail } from '@/api/api.js'
import { getFileType } from '@/utils/utils.js'
import ResourceDetail from '../../components/resourceDetail.vue'

export default {
  components: { ResourceDetail },
  name: 'Search',
  data: () => ({
    inputValue: '',
    termList: [],
    termValue: '',
    tagList: [],
    tagValue: '',
    authorityList: ['是', '否'],
    authorityValue: '',
    fileTypeList: ['图片', '视频', '音频', 'word', 'pdf', 'ppt'],
    fileTypeValue: '',
    selectTime: '',
    timeValue: '',

    showResult: false,
    data: [],
    pageNum: 1,
    total: 0,

    detailShow: false,
    detailData: {},
    origin: '',
  }),

  async mounted() {
    if (sessionStorage.getItem('yey-searchDetail')) {
      let searchDetail = JSON.parse(sessionStorage.getItem('yey-searchDetail'))
      this.detailShow = true
      // setTimeout(() => {
      //   this.origin = searchDetail.is_gfpt == 1 ? 2 : 1
      //   this.detailData = searchDetail
      // }, 10)
      resDetail(searchDetail.id).then((res) => {
        if (res.data.code == 0) {
          console.log('res', res)
          sessionStorage.setItem(
            'yey-searchDetail',
            JSON.stringify(res.data.data)
          )
          // this.detailShow = true
          setTimeout(() => {
            this.origin = res.data.data.is_gfpt == 1 ? 2 : 1
            this.detailData = res.data.data
          }, 10)
        }
      })
    }

    // let termRes = await getTerm()
    let termRes = await group()
    // console.log('termRes', termRes)
    this.termList = termRes.data.data

    let tagsRes = await getTags()
    // console.log('tagsRes', tagsRes)
    this.tagList = tagsRes.data.data

    if (sessionStorage.getItem('yey-searchInfo')) {
      let searchInfo = JSON.parse(sessionStorage.getItem('yey-searchInfo'))
      console.log('searchInfo', searchInfo)
      this.inputValue = searchInfo.inputValue
      this.termValue = searchInfo.termValue
      this.tagValue = searchInfo.tagValue
      this.authorityValue = searchInfo.authorityValue
      this.file_type = searchInfo.file_type
      this.timeValue = searchInfo.timeValue
      this.pageNum = searchInfo.pageNum
      this.toSearch()
    }
  },
  methods: {
    getFileType,
    getFileAuthor(item) {
      if (item.is_gfpt == 1) {
        // return '官方配套资源'
        return '配套资源'
      }
      return item.author
    },
    getDisplayCount(num) {
      if (num > 9999) {
        return Math.floor(num / 1000) / 10 + 'w'
      } else {
        return num
      }
    },
    toBack() {
      this.$router.back()
    },
    toInputValue() {
      console.log(document.getElementById('input').value)
      this.inputValue = document.getElementById('input').value
    },
    toSearchClick() {
      this.pageNum = 1
      this.toSearch()
    },
    toSearch() {
      // console.log('inputValue', this.inputValue)
      // return
      let data = { page: this.pageNum, status: 0, title: this.inputValue }
      if (this.termValue) {
        // data.term = this.termValue
        data.group1 = this.termValue
      }
      if (this.tagValue) {
        data.tag = this.tagValue
      }
      if (this.authorityValue) {
        data.is_gftj = this.authorityValue == '是' ? 1 : 0
      }
      if (this.fileTypeValue) {
        data.file_type = this.fileTypeValue
      }
      if (this.timeValue) {
        let date = new Date(this.timeValue)
        data.date = `${date.getFullYear()}-${date.getMonth() < 9 ? '0' : ''}${
          date.getMonth() + 1
        }-${date.getDate() < 10 ? '0' : ''}${date.getDate()}`
      }
      console.log('data', data)

      let searchInfo = {
        hasSearch: true,
        inputValue: this.inputValue,
        termValue: this.termValue,
        tagValue: this.tagValue,
        authorityValue: this.authorityValue,
        file_type: this.file_type,
        timeValue: this.timeValue,
        pageNum: this.pageNum,
      }
      sessionStorage.setItem('yey-searchInfo', JSON.stringify(searchInfo))

      // return
      findResource(data).then((res) => {
        this.data = res.data.data.list
        this.total = res.data.data.total
        this.showResult = true
      })
    },
    pageChange(e) {
      this.pageNum = e
      this.toSearch()
    },
    toPreview(item) {
      resDetail(item.id).then((res) => {
        if (res.data.code == 0) {
          console.log('res', res)
          sessionStorage.setItem(
            'yey-searchDetail',
            JSON.stringify(res.data.data)
          )
          // sessionStorage.setItem('yey-detail', JSON.stringify(res.data.data))
          // sessionStorage.setItem('yey-typeIndex', this.typeIndex)
          // this.detailData = res.data.data
          this.detailShow = true

          setTimeout(() => {
            this.origin = res.data.data.is_gfpt == 1 ? 2 : 1
            this.detailData = res.data.data
          }, 10)
        }
      })

      // console.log('toPreview', item)
      // this.$router.push({
      //   path: '/searchDetail',
      //   query: { id: item.id },
      // })
      // let searchDetail = item
      // sessionStorage.setItem('yey-searchDetail', JSON.stringify(searchDetail))
      // this.detailShow = true
      // setTimeout(() => {
      //   this.origin = item.is_gfpt == 1 ? 2 : 1
      //   this.detailData = item
      // }, 10)
    },
    onUpdateCollect(val) {
      this.detailData.is_collect = val
      if (val) {
        console.log(111)
        this.$set(this.detailData, 'collect', this.detailData.collect + 1)
      } else {
        console.log(222)
        this.$set(this.detailData, 'collect', this.detailData.collect - 1)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.pages-search {
  // min-width: 1600px;

  .top-line {
    display: flex;
    height: 84px;
    padding-left: 40px;
    align-items: center;
  }
  .small-button {
    width: 56px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid #00aeff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #00aeff;
    user-select: none;
    cursor: pointer;
  }
  .search-input {
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 100%;
    width: calc(100vw - 640px);
    max-width: 1280px;
    min-width: 900px;
    height: 190px;
    // min-width: 1561px;
    margin: 0 auto;
    .input-value {
      // width: 1280px;
      width: calc(100vw - 810px);
      max-width: 1280px;
      min-width: 730px;
      height: 90px;
      padding: 0 60px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      // color: #999999;
      color: #4d4d4d;
      line-height: 90px;
      background: #ffffff;
      border-radius: 45px 0 0 45px !important;
      border: none;
      box-sizing: border-box;
      // outline: 1px solid #10b3ff;
    }
    input::-webkit-input-placeholder {
      /* WebKit browsers*/
      color: #999999;
    }
    input:-moz-input-placeholder {
      /* Mozilla Firefox 4 to 18*/
      color: #999999;
    }
    input::-moz-input-placeholder {
      /* Mozilla Firefox 19+*/
      color: #999999;
    }
    input:-ms-input-placeholder {
      /* Internet Explorer 10+*/
      color: #999999;
    }
    .input-value:focus {
      border-radius: 45px 0 0 45px !important;
      outline: none !important;
      // outline: 1px solid #10b3ff !important;
      padding-left: 59px;
      border: 1px solid #10b3ff;
    }

    //   .el-input {
    //   background-color: #ccc !important;
    // }

    ::v-deep .input-value .el-input__inner {
      width: calc(100vw - 810px);
      max-width: 1280px;
      height: 90px;
      padding: 0 60px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      // color: #999999;
      color: #4d4d4d;
      line-height: 90px;
      background: #ffffff;
      border-radius: 45px 0 0 45px !important;
      border: none;
      box-sizing: border-box;
      &:focus {
        outline: 1px solid #10b3ff !important;
      }
    }

    .btn {
      width: 170px;
      height: 90px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 90px;
      text-align: center;
      background: #10b3ff;
      border-radius: 0px 45px 45px 0px;
      cursor: pointer;
    }
  }

  .search-select {
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 100%;
    // min-width: 1561px;
    width: calc(100vw - 360px);
    max-width: 1561px;
    min-width: 1000px;
    margin: 0 auto;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4d4d4d;
  }

  .search-select-title {
    flex-shrink: 0;
  }

  .result-total {
    position: absolute;
    left: 0;
    top: -76px;
    // width: 1561px;
    width: calc(100vw - 360px);
    max-width: 1561px;
    margin: 40px auto 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4d4d4d;
    line-height: 16px;
  }
  .result-table {
    position: relative;
    // width: 1561px;
    width: calc(100vw - 360px);
    max-width: 1561px;
    min-width: 1000px;
    // height: 562px;
    // height: calc(100vh - 510px);
    min-height: calc(100vh - 530px);
    // margin: 0 auto;
    margin: 76px auto 0;
    background: #ffffff;
    border-radius: 10px 10px 0px 0px;
    .data {
      display: flex;
      justify-content: center;
      align-items: center;
      .data-item {
        margin-right: 29px;
        font-size: 14px;
        color: #4c4c4c;
        &:last-child {
          margin-right: 0;
        }
        .data-icon {
          margin-right: 4px;
        }
      }
    }
    .pagination {
      position: absolute;
      bottom: 10px;
      right: 10px;
      float: right;
    }
  }

  .resource-detail-block {
    position: fixed;
    top: 100px;
    left: 0;
    width: 100vw;
    padding: 0 140px;
    height: calc(100vh - 100px);
    background: #f2f5f8;
    box-sizing: border-box;
    z-index: 9;
    .top-line {
      display: flex;
      height: 81px;
      align-items: center;
    }
    .small-button {
      width: 56px;
      height: 24px;
      border-radius: 12px;
      border: 1px solid #00aeff;
      text-align: center;
      line-height: 24px;
      font-size: 14px;
      color: #00aeff;
      user-select: none;
      cursor: pointer;
    }
    .title {
      font-size: 18px;
      color: #4d4d4d;
      margin-left: 20px;
    }
  }
}
</style>
